import { UserAttributeDocument } from './userattributedocument';

export class UserAttribute {

    public userAttributeID: number = 0;
    public name: string = '';
    public desc: string = '';
    public label: string = '';
    public attributeCode: string = '';
    public attributeRequired: boolean = false;
    public attributeValue: any;
    public userAttributeDocument: UserAttributeDocument = new UserAttributeDocument();

}
